import React, {
  CSSProperties,
  Dispatch,
  FC,
  SetStateAction,
  useLayoutEffect,
  useState,
} from "react"
import styles from "../styles/Menu.module.scss"

interface MenuProps {
  setTotalMin: Dispatch<SetStateAction<number>>
  lastScore: string | null
  topScore: string | null
  totalMin: number
  removeTop: () => void
  toggleHowTo: () => void
}

const Menu: FC<MenuProps> = ({
  setTotalMin,
  lastScore,
  topScore,
  totalMin,
  removeTop,
  toggleHowTo,
}) => {
  const [oneStyle, setOneStyle] = useState<CSSProperties>({
    fontWeight: "700",
    textDecorationLine: "underline",
  })
  const [twoStyle, setTwoStyle] = useState({
    fontWeight: "300",
    textDecorationLine: "none",
  })
  const [threeStyle, setThreeStyle] = useState({
    fontWeight: "300",
    textDecorationLine: "none",
  })

  useLayoutEffect(() => {
    switch (totalMin) {
      case 1:
        setOneStyle({ fontWeight: "700", textDecorationLine: "underline" })
        setThreeStyle({ fontWeight: "300", textDecorationLine: "none" })
        setTwoStyle({ fontWeight: "300", textDecorationLine: "none" })
        break
      case 2:
        setTwoStyle({ fontWeight: "700", textDecorationLine: "underline" })
        setOneStyle({ fontWeight: "300", textDecorationLine: "none" })
        setThreeStyle({ fontWeight: "300", textDecorationLine: "none" })
        break
      case 3:
        setThreeStyle({ fontWeight: "700", textDecorationLine: "underline" })
        setOneStyle({ fontWeight: "300", textDecorationLine: "none" })
        setTwoStyle({ fontWeight: "300", textDecorationLine: "none" })
        break
      default:
        setOneStyle({ fontWeight: "700", textDecorationLine: "underline" })
        setThreeStyle({ fontWeight: "300", textDecorationLine: "none" })
        setTwoStyle({ fontWeight: "300", textDecorationLine: "none" })
    }
  }, [totalMin])

  const oneMinHandler = () => {
    setTotalMin(1)
    setOneStyle({ fontWeight: "700", textDecorationLine: "underline" })
    setThreeStyle({ fontWeight: "300", textDecorationLine: "none" })
    setTwoStyle({ fontWeight: "300", textDecorationLine: "none" })
  }

  const twoMinHandler = () => {
    setTotalMin(2)
    setTwoStyle({ fontWeight: "700", textDecorationLine: "underline" })
    setOneStyle({ fontWeight: "300", textDecorationLine: "none" })
    setThreeStyle({ fontWeight: "300", textDecorationLine: "none" })
  }

  const threeMinHandler = () => {
    setTotalMin(3)
    setThreeStyle({ fontWeight: "700", textDecorationLine: "underline" })
    setOneStyle({ fontWeight: "300", textDecorationLine: "none" })
    setTwoStyle({ fontWeight: "300", textDecorationLine: "none" })
  }

  const resetWarningHandler = () => {
    if (window.confirm("Delete Top Score?") === true) {
      removeTop()
    }
  }

  return (
    <div className={styles.menu}>
      <div className={styles.items}>
        <div>
          <button onClick={toggleHowTo} className={styles.howToBtn}>
            How to Play
          </button>
        </div>
        <h2 className={styles.modesTitle}>Modes</h2>
        <h3 style={oneStyle} onClick={oneMinHandler} className={styles.modes}>
          1 minute
        </h3>
        <h3 style={twoStyle} onClick={twoMinHandler} className={styles.modes}>
          2 minutes
        </h3>
        <h3
          style={threeStyle}
          onClick={threeMinHandler}
          className={styles.modes}
        >
          3 minutes
        </h3>
        {/* <h3 className={styles.modes}>3 Misses</h3> */}
      </div>
      <div className={styles.savedContainer}>
        <div className={styles.saved}>
          <h2 className={styles.lastScore}>Last Score: {lastScore}</h2>
          <h2 className={styles.topScore}>Top Score: {topScore}</h2>
        </div>
      </div>
      <div className={styles.link}>
        <a
          href="https://buymeacoffee.com/scottfly40"
          target="_blank"
          rel="noreferrer"
        >
          Buy Me A Coffee
        </a>
        <div>
          <button className={styles.btn} onClick={resetWarningHandler}>
            Reset Top Score
          </button>
        </div>
      </div>
    </div>
  )
}

export default Menu
